module.exports = __webpack_public_path__ + "img/logo.1bc5a34a.png";